<template>
    <section class="test-drive">
        <PreviousStep />
        <div class="select-datetime__content" id="target-section">
            <div class="select-datetime__content--details">
                <selected-vehicle-details :model="model" :dealership="dealer.name"></selected-vehicle-details>
            </div>
            <div class="select-datetime__content--main">
                <div class="card select-datetime__calender">
                    <p class="select-datetime__title">Please choose a date: <span class="select-datetime__date">{{ date }}</span></p>
                    <div class="select-datetime__content--form">
                        <div class="select-datetime__content--input">
                        <div v-if="loadingDays == false">
                            <date-picker :closedDays="closedDays" :minDate="minDate" :maxDate="maxDate"></date-picker>
                        </div>
                        </div>
                    </div>
                    <TimeSelect
                        :times="times"
                        :chosen-time="chosenTime"
                        title="Preferred time of collection:"
                        @time-selected="handleTimeSelection"
                    />
                    <div class="select-datetime__content--button">
                        <button type="button" class="btn btn-primary select-datetime__button" @click="selectDateTime()">
                            CONTINUE
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PreviousStep from "../PreviousStep";
import SelectedVehicleDetails from "../SelectedVehicleDetails.vue"
import DatePicker from "../DatePicker.vue"
import EventObject from "../../../../modules/tracking/EventObject";
import { addDays } from 'date-fns';
import TimeSelect from "./TimeSelect.vue";

export default {
    components: {
        SelectedVehicleDetails,
        PreviousStep,
        DatePicker,
        TimeSelect,
    },
    data() {
        return {
            chosenDate:null,
            chosenTime:null,
            minDate: null,
            maxDate: null,
            dayTimes: null,
            bankHolidays: [],
        };
    },
    mounted() {
    },
    created() {
        this.$nextTick(() => {
            this.scrollToTop();
        });

        this.minDate = addDays(new Date(), 4);
        this.maxDate = addDays(new Date(), 90); 
    },
    methods: {
        selectDateTime(dealership) {
            if (this.haveMinimumData == true) {
                this.$store.dispatch("navigatorStep", this.currentStep.next);
            }
        },
        handleTimeSelection(time) {
            this.chosenTime = time;
            this.$store.commit("setTime",  this.chosenTime);
        },
        scrollToTop() {
            const storedPosition = this.scrollPosition;
            if (storedPosition) {
                window.scrollTo({ top: storedPosition, behavior: 'smooth' });
            }
        },
    },
    computed: {
        ...mapGetters(["currentStep", 'model', 'getDealerClosedDays', 'getDealerBankHolidays']),
        ...mapState(['dealer', 'date', 'times', 'time', 'loadingDays', 'datePage','scrollPosition']),

        haveMinimumData() {
            if (!this.date) {
                return false;
            }
            if (!this.time) {
                return false;
            }
            return true;
        },

        closedDays(){
            return this.getDealerClosedDays.concat(this.getDealerBankHolidays)
        },
    },
};
</script>

<style lang="scss" scoped>
.select-datetime {
    &__calender{
       padding: 0 3rem 2rem 3rem;
       @media (max-width: 550px) {
          padding: 0 1rem 2rem 1rem;
      }
    }
    &__date{
        color: rgba(0, 147, 214, 1);
    }
    &__button{
        width: 50%;
        min-width: 295px;
    }
    &__content {
        margin-top: 1rem;
        display:grid;
        grid-template-columns: 1.9fr 5.9fr;
        grid-gap: 14px;
        justify-content: space-between;
        &--button {
            margin-top: 2rem;
            font-size: 20px;
            display: grid;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        &--form {
            display: flex;
            justify-content: space-between;
            gap: 54px;

            @media (max-width: 800px) {
                flex-direction: column-reverse;
            }
        }

        &--input {
            width: 100%;

            @media (max-width: 800px) {
                width: 100%;
            }
        }

        &--options {
            .active {
                background-color: #0093d6;
                color: #fff;
            }
            @media (max-width: 550px) {
                align-items: start;
                flex-direction: column;
            }
        }
        &--select{
            margin-left: 1rem;
            width: inherit;
            @media (max-width: 550px) {
               width: 100%;
               margin-left: 0rem;
            }
        }
    }

    @media (max-width: 550px) {
        &__content {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
        }

        &__content--main {
          order: 1;
        }

        &__content--details {
          order: 2;
        }
      }
}
</style>